export default __webpack_public_path__ + "static/media/minha-encomenda-ecommerce-min.cb762550.png";